import { renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, resolveComponent as _resolveComponent, withCtx as _withCtx, createSlots as _createSlots, createBlock as _createBlock, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps } from "vue"

const _hoisted_1 = { class: "ds-table ds-table--styling_primary" }
const _hoisted_2 = {
  key: 0,
  class: "ds-table__head"
}
const _hoisted_3 = { class: "ds-table__row" }
const _hoisted_4 = {
  key: 0,
  class: "ds-table__cell ds-table__cell--head ds-table__cell--appearance_action-head"
}
const _hoisted_5 = ["data-title"]
const _hoisted_6 = {
  key: 0,
  class: "ds-table__foot"
}
const _hoisted_7 = { class: "ds-table__tr ds-table__tr--relief" }
const _hoisted_8 = {
  key: 0,
  class: "ds-table__cell ds-table__cell--head ds-table__cell--appearance_action-head"
}
const _hoisted_9 = ["data-title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_vue_table_item = _resolveComponent("vue-table-item")!

  return (_openBlock(), _createElementBlock("table", _hoisted_1, [
    _renderSlot(_ctx.$slots, "head", {
      fields: $setup.props.fields
    }, () => [
      ($setup.props.displayHeader)
        ? (_openBlock(), _createElementBlock("thead", _hoisted_2, [
            _createElementVNode("tr", _hoisted_3, [
              (_ctx.$slots.action)
                ? (_openBlock(), _createElementBlock("th", _hoisted_4, [
                    _renderSlot(_ctx.$slots, "action-head")
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.fields, (field) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: _normalizeClass(["ds-table__cell ds-table__cell--head", [ `ds-table__cell--appearance_field-${field.key}`, `ds-table__cell--appearance_head-${field.key}` ]]),
                  key: field.key,
                  "data-title": field.label
                }, [
                  _renderSlot(_ctx.$slots, `head-cell-${field.key}`, {
                    fields: $setup.props.fields,
                    field: field
                  }, () => [
                    _renderSlot(_ctx.$slots, "head-cell", {
                      fields: $setup.props.fields,
                      field: field
                    }, () => [
                      _createTextVNode(_toDisplayString(field.label), 1)
                    ])
                  ])
                ], 10, _hoisted_5))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.items, (item, i) => {
      return _renderSlot(_ctx.$slots, "item", {
        fields: $setup.props.fields,
        item: item,
        index: i
      }, () => [
        (_openBlock(), _createBlock(_component_vue_table_item, {
          key: i,
          fields: $setup.props.fields,
          item: item,
          index: i
        }, _createSlots({ _: 2 }, [
          _renderList(_ctx.$slots, (slot, name) => {
            return {
              name: name,
              fn: _withCtx((scope) => [
                _renderSlot(_ctx.$slots, name, _mergeProps({ ref_for: true }, scope))
              ])
            }
          })
        ]), 1032, ["fields", "item", "index"]))
      ])
    }), 256)),
    _renderSlot(_ctx.$slots, "after-body", {}, () => [
      ($setup.props.aggregate)
        ? (_openBlock(), _createBlock(_component_vue_table_item, {
            key: 0,
            fields: $setup.props.aggregateFields,
            item: $setup.props.aggregate,
            index: 1,
            relief: true
          }, _createSlots({ _: 2 }, [
            _renderList(_ctx.scopedSlots, (slot, key) => {
              return {
                name: key,
                fn: _withCtx((scope) => [
                  _renderSlot(_ctx.$slots, key, _normalizeProps(_guardReactiveProps(scope)))
                ])
              }
            })
          ]), 1032, ["fields", "item"]))
        : _createCommentVNode("", true)
    ]),
    _renderSlot(_ctx.$slots, "foot", {
      fields: $setup.props.fields
    }, () => [
      ($setup.props.displayFooter)
        ? (_openBlock(), _createElementBlock("tfoot", _hoisted_6, [
            _createElementVNode("tr", _hoisted_7, [
              (_ctx.$slots.action)
                ? (_openBlock(), _createElementBlock("th", _hoisted_8, [
                    _renderSlot(_ctx.$slots, "action-head")
                  ]))
                : _createCommentVNode("", true),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.props.fields, (field) => {
                return (_openBlock(), _createElementBlock("th", {
                  class: _normalizeClass(["ds-table__cell ds-table__cell--head", [ `ds-table__cell--appearance_field-${field.key}`, `ds-table__cell--appearance_head-${field.key}` ]]),
                  key: field.key,
                  "data-title": field.label
                }, [
                  _renderSlot(_ctx.$slots, `foot-cell-${field.key}`, {
                    fields: $setup.props.fields,
                    field: field
                  }, () => [
                    _renderSlot(_ctx.$slots, "foot-cell", {
                      fields: $setup.props.fields,
                      field: field
                    }, () => [
                      _createTextVNode(_toDisplayString(field.label), 1)
                    ])
                  ])
                ], 10, _hoisted_9))
              }), 128))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}